import {useEffect} from "react";



// {
//     "value": "Certificate rotation",
//     "label": "Certificate rotation"
// },
// {
//     "value": "Cleaning",
//     "label": "Cleaning"
// },
// {
//     "value": "DGUV",
//     "label": "DGUV"
// },
// {
//     "value": "Electrician Support",
//     "label": "Electrician Support"
// },
// {
//     "value": "Greasing",
//     "label": "Greasing"
// },
// {
//     "value": "Intervention 4h",
//     "label": "Intervention 4h"
// },
// {
//     "value": "Intervention NBD",
//     "label": "Intervention NBD"
// },
// {
//     "value": "Intervention Weekend",
//     "label": "Intervention Weekend"
// },
// {
//     "value": "On-Site Audit",
//     "label": "On-Site Audit"
// },
// {
//     "value": "Sweep",
//     "label": "Sweep"
// }

export default function AmazonLockerWidget({ locker_service_type, form  }) {

    useEffect(() => {
        if(locker_service_type === 'Certificate rotation') {
            form.change("orderattributes.sla", "10 BD");
        }
        if(locker_service_type === 'Cleaning') {
            form.change("orderattributes.sla", "Other");
        }
        if(locker_service_type === 'DGUV') {
            form.change("orderattributes.sla", "Other");
        }
        if(locker_service_type === 'Electrician Support') {
            form.change("orderattributes.sla", "next BD");
        }
        if(locker_service_type === 'Greasing') {
            form.change("orderattributes.sla", "15 BD");
        }
        if(locker_service_type === 'Intervention 4h') {
            form.change("orderattributes.sla", "4hr");
        }
        if(locker_service_type === 'Intervention NBD') {
            form.change("orderattributes.sla", "next BD");
        }
        if(locker_service_type === 'Intervention Weekend') {
            form.change("orderattributes.sla", "4hr");
        }
        if(locker_service_type === 'On-Site Audit') {
            form.change("orderattributes.sla", "10 BD");
        }
        if(locker_service_type === 'Sweep') {
            form.change("orderattributes.sla", "10 BD");
        }

    }, [locker_service_type]);

    return (
        <div className={'h-0 -my-[12px]'}>
        </div>
    );
}
